module.exports = __webpack_public_path__ + "img/ico_sign_out_dark.1ce5b000.svg";